// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"tooltip-module--toolTip--1WI7K","toolTipText":"tooltip-module--toolTipText--15tvR"};